export default __webpack_public_path__ + "static/media/heavy_modular_frame.fbb37b63.png";